import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

const hasExplicitOffset = (value: string): boolean =>
  /(?:Z|[+-]\d{2}:?\d{2})$/.test(value.trim());

/**
 * Parse or convert a date into the given timezone.
 * UTC/offset ISO strings are treated as instants; naive strings use wall clock in `timezone`.
 */
export const dayJsTz = (timezone: string, date?: dayjs.ConfigType) => {
  if (date == null || date === '') {
    return dayjs().tz(timezone);
  }

  if (typeof date === 'string') {
    const trimmed = date.trim();

    if (hasExplicitOffset(trimmed)) {
      return dayjs(trimmed).tz(timezone);
    }

    return dayjs.tz(trimmed.replace(' ', 'T'), timezone);
  }

  return dayjs(date).tz(timezone);
};
